module.exports = __webpack_public_path__ + "media/images/logos/Google-68483b15a2c23d54c1ef181ef0766220.png";